import { render } from "./GuestPaymentMethod.vue?vue&type=template&id=6b6d5483&scoped=true"
import script from "./GuestPaymentMethod.vue?vue&type=script&lang=js"
export * from "./GuestPaymentMethod.vue?vue&type=script&lang=js"

import "./GuestPaymentMethod.vue?vue&type=style&index=0&id=6b6d5483&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6d5483"]])

export default __exports__